import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import "./FavoriteItems.css";
import {
  fetchFavoriteItems,
  deleteFavoriteItem,
  FavouriteItemWithPricesViewModel,
} from "./favoriteItemsSlice";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ColDef } from "ag-grid-community";

const FavoriteItemsOption: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data, loading, error } = useSelector((state: RootState) => state.favoriteItems);
  const [gridApi, setGridApi] = useState<any>(null);
  const [isMobileView, setIsMobileView] = useState<boolean>(false);

  const conditionNames = [
    { id: 1, name: "New" },
    { id: 2, name: "New other (see details)" },
    { id: 3, name: "Manufacturer refurbished" },
    { id: 4, name: "Seller refurbished" },
    { id: 5, name: "Used" },
    { id: 6, name: "Very Good" },
    { id: 7, name: "Acceptable" },
    { id: 8, name: "For parts or not working" },
  ];

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchFavoriteItems());
    }

    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch, data.length]);

  const onGridReady = (params: any) => {
    setGridApi(params.api); // Save the grid API to state
    params.api.sizeColumnsToFit(); // Automatically adjust column sizes
  };

  const handleAddRow = () => {
    const newItem: FavouriteItemWithPricesViewModel = {
      id: Math.random(), // Temporary unique ID
      name: "",
      createDate: new Date().toISOString(),
      conditionPrice: conditionNames.map((condition) => ({
        conditionID: condition.id,
        price: 0, // Default price
        conditionName:''
      })),
    };

    gridApi.applyTransaction({ add: [newItem] });
  };

  const handleSave = async () => {
    const updatedData = gridApi.getRowData() || [];
    try {
      for (const item of updatedData) {
        if (!item.name.trim()) {
          alert("All items must have a name.");
          return;
        }
      }
    //   await dispatch(addFavoriteItem(updatedData));
      alert("Items saved successfully.");
      dispatch(fetchFavoriteItems());
    } catch (error) {
      console.error("Failed to save items:", error);
    }
  };

  const handleDelete = (id: number) => {
    gridApi.applyTransaction({ remove: [{ id }] });
  };

  const columnDefs: ColDef[] = [
    {
      headerName: "Name",
      field: "name",
      editable: true, // Allow inline editing
      sortable: true,
      filter: true,
      flex: 1,
    },
    {
      headerName: "Create Date",
      field: "createDate",
      valueFormatter: (params) =>
        params.value ? new Date(params.value).toLocaleString() : "N/A",
      flex: 1,
    },
    ...conditionNames.map((condition) => ({
        headerName: condition.name,
        field: `conditionPrice.${condition.id}`,
        editable: true, // Allow editing prices
        valueGetter: (params: { data: FavouriteItemWithPricesViewModel }) => {
          const conditionPrice = params.data.conditionPrice.find(
            (c: any) => c.conditionID === condition.id
          );
          return conditionPrice?.price ?? "N/A";
        },
        valueSetter: (params: { data: FavouriteItemWithPricesViewModel; newValue: string }) => {
          const conditionPrice = params.data.conditionPrice.find(
            (c: any) => c.conditionID === condition.id
          );
          if (conditionPrice) {
            conditionPrice.price = parseFloat(params.newValue) || 0;
            return true;
          }
          return false;
        },
        flex: 1,
      })),
      
    {
      headerName: "Actions",
      cellRenderer: (params: any) => (
        <button
          onClick={() => handleDelete(params.data.id)}
          style={{ padding: "5px 10px", cursor: "pointer" }}
        >
          Delete
        </button>
      ),
      flex: 1,
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <div className="toolbar">
        <button onClick={handleAddRow} className="toolbar-button">
          + Add Item
        </button>
        <button onClick={handleSave} className="toolbar-button">
          Save Changes
        </button>
      </div>

      {isMobileView ? (
        <div className="favorite-items-mobile">
          {data.map((item) => (
            <div key={item.id} className="favorite-item-card">
              <h3>Item: {item.name || "New Item"}</h3>
              <p>
                Created: {new Date(item.createDate).toLocaleString() || "N/A"}
              </p>
              <div className="condition-list">
                {conditionNames.map((condition) => {
                  const price =
                    item.conditionPrice?.find(
                      (c) => c.conditionID === condition.id
                    )?.price || "N/A";
                  return (
                    <div key={condition.id}>
                      <strong>{condition.name}:</strong> {price}
                    </div>
                  );
                })}
              </div>
              <button
                onClick={() => handleDelete(item.id)}
                className="delete-button"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="ag-theme-alpine-favorite-item" style={{ height: 600, width: "100%" }}>
          <AgGridReact
            rowData={data}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            pagination={true}
            paginationPageSize={50}
            domLayout="autoHeight"
            animateRows={true}
            defaultColDef={{
              resizable: true,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FavoriteItemsOption;
